const capitalize = (text: string | undefined) => {
    if (!text) return '';
    return text.toUpperCase();
};

const onlyFirstCapitalize = (text: string | undefined) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1)?.toLowerCase();
};

const toTitleCase = (text: string | undefined) => {
    if (!text) return '';

    return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('-');
};

export {
    capitalize,
    onlyFirstCapitalize,
    toTitleCase
}